module.exports = __webpack_public_path__ + "img/success.a4633461.svg";